import React, {PureComponent} from 'react';
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import Head from 'next/head';
import dynamic from 'next/dynamic';

import {loadReservations, getStats} from '../../reducers/reservations'
import {debounce} from '../../libs/throttle-debounce';

import Container from "@material-ui/core/Container";
import Hidden from "@material-ui/core/Hidden";
import {Dashboard as DashboardLayout} from '../../layouts';
const ReservationsTable = dynamic(() => import('./components/ReservationsTable'));
const Cards = dynamic(() => import('./components/Cards'));
const Filters = dynamic(() => import('./components/Filters'));
const Snackbar = dynamic(() => import('../../components/Snackbar/Snackbar'));


class Reservations extends PureComponent {

    componentDidMount() {
        const {loadReservations, pagination, router} = this.props;
        const {id, group, onboard, ...query} = router.query;
        if (id) {
            loadReservations({id, ...pagination, ...query});
            this.getStats({id})
        }
        else {
            loadReservations({...pagination, ...query});
            this.getStats({})
        }
    }

    getStats = (props) => {
        const {getStats, stats} = this.props;
        if (!stats || !stats.total || stats.total === 0) {
            getStats(props)
        }
    }

    render() {
        const {router, loadReservations} = this.props;
        const {onboard} = router.query;
        return (
            <DashboardLayout title="Reservations">
                <Container maxWidth="lg">
                    <Head>
                        <title>Reservations</title>
                    </Head>

                    <Hidden smDown>
                        <Cards
                            router={router}
                            onChange={loadReservations}
                        />
                    </Hidden>
                    <Filters
                        router={router}
                        onChange={loadReservations}
                    />
                    <ReservationsTable
                        router={router}
                        fetch={debounce(loadReservations, 350)}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        selectable={Boolean(onboard)}
                    />
                </Container>
                <Snackbar/>
            </DashboardLayout>
        )
    }
}

Reservations.propTypes = {
    router: PropTypes.object.isRequired,
    loadReservations: PropTypes.func.isRequired,
    getStats: PropTypes.func.isRequired,
    reservations: PropTypes.array.isRequired,
}

const mapStateToProps = (state) => {
    return {
        reservations: state.reservations.reservations,
    }
}

export {Reservations}
export default compose(
    connect(mapStateToProps, {loadReservations, getStats}),
)(Reservations)
